//-----------------------------------------------------------------------
//
// 共用定義
//

//-----------------------------------------------------------------------
/** API 返回結果代碼。 */
export enum API_RESULT_CODE
{
	/** --- 通用代碼 ---------------- */

	/** 成功。 */
	Succeeded						= 1,

	/** 失敗，不需指定原因時使用。 */
	Failed							= 0,

	/** 伺服器離線中。 */
	ServerOffline					= -100,

	/** 缺少必須參數。 */
	ParameterMissing				= -101,

	/** 尚未連線。 */
	NotConnected					= -102,

	/** 存取被拒。 */
	AccessDenied					= -103,

	/** e-mail 不合規格。 */
	InvalidEmail					= -110,

	/** 手機號碼不合規格。 */
	InvalidPhoneNumber				= -111,

	/** 密碼設定不合規格。 */
	InvalidPassword					= -112,

	/** 參數輸入內容不合規格。 */
	InvalidParameter				= -113,

	/** 網路錯誤。 */
	NetworkError					= -120,

	/** 服務還不可使用，通常為有使用時間間隔限制的 API。 */
	ServiceNotAvailableYet			= -201,

	/** --- 管理員相關 ---------------- */

	/** 管理員帳號已建立。 */
	MemberAlreadyCreated			= -500,

	/** 無法建立新管理員。 */
	MemberCreateFailed				= -501,

	/** 管理員帳號不存在。 */
	MemberNotExists					= -502,

	/** 管理員帳號失效。 */
	MemberNotEnabled				= -503,

	/** 登入失敗。 */
	MemberLoginFailed				= -504,

	/** 尚未登入。 */
	MemberNotLoggedIn				= -505,

	/** 管理員 email 已被使用中。 */
	MemberEmailAlreadyUsed			= -506,

	/** 管理員群組不可使用。 */
	MemberGroupNotAllowed			= -507,

	/** 管理員權限不可使用。 */
	MemberPermissionNotAllowed		= -508,

	/** --- 系統資料相關 ---------------- */

	/** 資料來源已建立。 */
	SourceAlreadyCreated			= -1000,

	/** 無法建立新資料來源。 */
	SourceCreateFailed				= -1001,

	/** 資料來源不存在。 */
	SourceNotExists					= -1002,

	/** 資料來源 url 已有其他來源使用。 */
	SourceUrlAlreadyUsed			= -1003,

	/** 區域不存在。 */
	RegionNotExists					= -1010,

	/** 關鍵字已建立。 */
	KeywordAlreadyCreated			= -1100,

	/** 無法建立新關鍵字。 */
	KeywordCreateFailed				= -1101,

	/** 關鍵字不存在。 */
	KeywordNotExists				= -1102,

	/** 關鍵字內容已被使用。 */
	KeywordTextAlreadyUsed			= -1103,

	/** 手動新增頻道已建立。 */
	ManuallyChannelAlreadyCreated	= -1200,

	/** 無法建立新手動新增頻道。 */
	ManuallyChannelCreateFailed		= -1201,

	/** 手動新增頻道不存在。 */
	ManuallyChannelNotExists		= -1202,

	/** 手動新增頻道已建立過。 */
	ManuallyChannelAlreadyUsed		= -1203,

	/** KOL 已建立。 */
	KolAlreadyCreated				= -1300,

	/** 無法建立新 KOL。 */
	KolCreateFailed					= -1301,

	/** KOL 不存在。 */
	KolNotExists					= -1302,

	/** KOL 名稱已被使用。 */
	KolNameAlreadyUsed				= -1303,

	/** 無法建立排程工作。 */
	ScheduleTaskCreateFailed		= -1400,

	/** 排程工作不存在。 */
	ScheduleTaskNotExists			= -1401,

	/** 排程工作已建立過。 */
	ScheduleTaskAlreadyUsed			= -1402,

	/** --- 統計相關 ---------------- */

	/** 頻道不存在。 */
	ChannelNotExists				= -2000,

	/** 目標不存在。 */
	TargetNotExists					= -2100,
}

//-----------------------------------------------------------------------

/** 系統設定資料類型。 */
export enum SYSTEM_SETTING
{
	// Cloud function 呼叫網址。

	/** Youtube 全站關鍵字搜尋。 */
	YouTubeSearcher					= 100,

	/** Youtube 目標資料抓取。 */
	YouTubeTargetTracker,

	/** Youtube 頻道資料抓取。 */
	YouTubeChannelTracker,

	/** Youtube 頻道內關鍵字搜尋。 */
	YouTubeChannelSearcher,

	/** TikTok 全站關鍵字搜尋。 */
//	TikTokSearcher					= 110,

	/** Youtube 目標資料抓取。 */
	TikTokTargetTracker				= 111,

	/** Youtube 頻道資料抓取。 */
	TikTokChannelTracker,

	/** Youtube 頻道內關鍵字搜尋。 */
	TikTokChannelSearcher,

	/** Facebook 粉絲頁資料抓取。 */
	FacebookTracker					= 120,

	/** 外部帳號。 */
	TikTokAccountInfo				= 200,
}

/** 通用兩態狀態。 */
export enum COMMON_STATUS
{
	/** 有效。 */
	Enable						= 'enable',

	/** 無效。 */
	Disable						= 'disable',
}

/** 通用三態狀態。 */
export enum COMMON_THREE_STATUS
{
	/** 有效。 */
	Enable						= 'enable',

	/** 無效。 */
	Disable						= 'disable',

	/** 已刪除。 */
	Deleted						= 'deleted',
}

/** 關鍵字搜尋上限範圍。 */
export enum KEYWORD_SEARCH_LIMIT
{
	Min							= 1,
	Max							= 1000
}

/** 資料來源名稱。 */
export enum SOURCE_NAME
{
	YouTube						= 'YouTube',
	TikTok						= 'TikTok',
	Facebook					= 'Facebook',
	Instagram					= 'Instagram'
}

/** 資料來源頻道與目標追蹤設定。 */
export enum SOURCE_TRACK_SETTING
{
	All							= 'all',
	Specify						= 'specify'
}

//-----------------------------------------------------------------------
// 管理員相關

/**
 * 管理員群組定義。
 * 除產生預設權限外，群組層級也會限制權限的有效範圍(例如編輯管理員時不可編輯比自身群組高的管理員資料)。
 * 數字範圍之間可再設定更細的定義。
 */
export enum MEMBER_GROUP
{
	/**
	 * 擁有者、最高權限管理者。
	 * 預設開啟所有權限。
	 */
	Owner						= 1,

	/**
	 * 管理者，可使用除變更擁有者及其他管理者以外的所有功能。
	 * 預設開啟所有權限。
	 */
	Manager						= 100,

	/**
	 * 編輯者，可使用變更管理員以外的功能。
	 * 預設開啟 edit、view 權限，但編輯 log 只看得到自己的。
	 */
	Editor						= 500,

	/**
	 * 檢視者，只可瀏覽不可變更資料。
	 * 預設只有 keyword、manually channel、source、region、channel、target 以外的 view 權限，無法看到編輯 log。
	 */
	Viewer						= 900,

	/**
	 * 訪客，只可瀏覽有限開放的資料。
	 * 預設只有 keyword、source、region、channel、target 的 view 權限。
	 */
	Guest						= 999
}

/**
 * 管理員權限項目。
 * 群組之下再細分的功能權限，權限設定本身不可超過群組的許可範圍。
 */
export enum MEMBER_PERMISSION
{
	MemberView					= 0x00000001,
	MemberEdit					= 0x00000002,
	MemberCreate				= 0x00000004,

	KolView						= 0x00000008,
	KolEdit						= 0x00000010,
	KolCreate					= 0x00000020,

	KeywordView					= 0x00000040,
	KeywordEdit					= 0x00000080,
	KeywordCreate				= 0x00000100,

	ManuallyChannelView			= 0x00000200,
	ManuallyChannelEdit			= 0x00000400,
	ManuallyChannelCreate		= 0x00000800,

	SourceView					= 0x00001000,
	SourceEdit					= 0x00002000,

	RegionView					= 0x00004000,
	RegionEdit					= 0x00008000,

	ChannelView					= 0x00010000,
	ChannelEdit					= 0x00020000,

	TargetView					= 0x00040000,
	TargetEdit					= 0x00080000,

	ScheduleView				= 0x00100000,
	ScheduleEdit				= 0x00200000,
	ScheduleCreate				= 0x00400000,

	/** 所有的檢視權限。 */
	AllView						= MemberView | KolView | KeywordView | ManuallyChannelView | SourceView | RegionView | ChannelView | TargetView | ScheduleView,
	// 0x00000001 | 0x00000008 | 0x00000040 | 0x00000200 | 0x00001000 | 0x00004000 | 0x00010000 | 0x00040000 | 0x00100000 = 0x00155249 = 1397321

	/** 所有的編輯權限。 */
	AllEdit						= MemberEdit | KolEdit | KeywordEdit | ManuallyChannelEdit | SourceEdit | RegionEdit | ChannelEdit | TargetEdit | ScheduleEdit,
	// 0x00000002 | 0x00000010 | 0x00000080 | 0x00000400 | 0x00002000 | 0x00008000 | 0x00020000 | 0x00080000 | 0x00200000 = 0x002AA492 = 2794642

	/** 所有的建立權限。 */
	AllCreate					= MemberCreate | KolCreate | KeywordCreate | ManuallyChannelCreate | ScheduleCreate,
	// 0x00000004 | 0x00000020 | 0x00000100 | 0x00000800 | 0x00400000 = 0x00400924 = 4196644

	/** 擁有者預設權限。 */
	OwnerDefault				= AllView | AllEdit | AllCreate,
	// 0x00155249 | 0x002AA492 | 0x00400924 = 0x007fffff = 8388607

	/** 管理者預設權限。 */
	ManagerDefault				= AllView | AllEdit | AllCreate,
	// 0x00155249 | 0x002AA492 | 0x00400924 = 0x007fffff = 8388607

	/** 編輯者預設權限。 */
	EditorDefault				= AllView | KolEdit | KeywordEdit | ManuallyChannelEdit | SourceEdit | RegionEdit | ChannelEdit | TargetEdit | ScheduleEdit,
	// 0x00155249 | 0x00000010 | 0x00000080 | 0x00000400 | 0x00002000 | 0x00008000 | 0x00020000 | 0x00080000 | 0x00200000 = 0x003ff6d9 = 4191961

	/** 檢視者預設權限。 */
	ViewerDefault				= KeywordView | ManuallyChannelView | SourceView | RegionView | ChannelView | TargetView | ScheduleView,
	// 0x00000040 | 0x00000200 | 0x00001000 | 0x00004000 | 0x00010000 | 0x00040000 | 0x00100000 = 0x00155240 = 1397312

	/** 訪客預設權限。 */
	GuestDefault				= KeywordView | SourceView | RegionView | ChannelView | TargetView,
	// 0x00000040 | 0x00001000 | 0x00004000 | 0x00010000 | 0x00040000 = 0x00055040 = 348224
}

/** 管理員設定。 */
export enum MEMBER_SETTING
{
}

/** 管理員紀錄種類。 */
export enum MEMBER_LOG_TYPE
{
	/** --- 管理員相關 ---------------- */
	MemberLogin					= 100,
	MemberLogout,

	/** --- 資料操作相關 ---------------- */
	MemberCreate				= 1000,
	MemberModify,
	MemberDelete,

	SourceCreate				= 1100,
	SourceModify,

	RegionCreate				= 1110,
	RegionModify,

	KeywordCreate				= 1200,
	KeywordModify,

	ManuallyChannelCreate		= 1300,
	ManuallyChannelModify,

	ScheduleCreate				= 1310,
	ScheduleModify,

	KolCreate					= 1400,
	KolModify,

	ChannelModify				= 1500,
	TargetModify,

	/** --- 相關 ---------------- */

}

//-----------------------------------------------------------------------
// 關鍵字相關。

/** 關鍵字搜尋模式。 */
export enum KEYWORD_SEARCH_MODE
{
	/** 預設模式 - 來源全站搜尋和頻道內搜尋都會包含此關鍵字。 */
	Default						= 'default',

	/** 來源模式 - 只在來源全站搜尋時使用關鍵字，頻道內搜尋時排除。 */
	SourceOnly					= 'sourceOnly',
}

//-----------------------------------------------------------------------
// 頻道相關。

/** 頻道狀態。 */
export enum CHANNEL_STATUS
{
	/** 追蹤中。 */
	Tracking					= 'tracking',

	/** 不追蹤。 */
	Untracked					= 'untracked',
}

/** 頻道所包含關鍵字狀態。 */
export enum CHANNEL_KEYWORD_STATUS
{
	/** 有效。 */
	Enable						= 'enable',

	/** 無效。 */
	Disable						= 'disable',

	/** 已刪除。 */
	Deleted						= 'deleted',
}

/** 手動新增頻道狀態。 */
export enum MANUALLY_CHANNEL_STATUS
{
	/** 等待新增。 */
	Waiting						= 'waiting',

	/** 新增完畢。 */
	Finished					= 'finished',

	/** 新增失敗。 */
	Failed						= 'failed',
}

//-----------------------------------------------------------------------
// 目標相關。

/** 目標狀態。 */
export enum TARGET_STATUS
{
	/** 追蹤中。 */
	Tracking					= 'tracking',

	/** 不追蹤。 */
	Untracked					= 'untracked',
}

/** 目標媒體種類。 */
export enum TARGET_MEDIA_TYPE
{
	/** 一般影片。 */
	Video						= 'video',

	/** 短影片。 */
	Short						= 'short',

	/** 直播。 */
	Live						= 'live',

	/** 貼文。 */
	Post						= 'post'
}

//-----------------------------------------------------------------------
// 分析相關。

/** 分析時間範圍定義。 */
export enum ANALYTICS_TIME_RANGE
{
	/** 月份。 */
	Monthly						= 'm',

	/** 季度。 */
	Quarterly					= 'q',

	/** 年度。 */
	Yearly						= 'y'
}

/** 分析資料範圍定義。 */
export enum ANALYTICS_DATA_RANGE
{
	/** 依關鍵字。 */
	Keyword						= 'k',

	/** 依頻道。 */
	Channel						= 'c',

	/** 依頻道關鍵字。 */
	ChannelKeyword				= 'ck',

	/** 依目標。 */
	Target						= 't'
}

//-----------------------------------------------------------------------
// 排程工作相關。

/** 排程工作種類。 */
export enum SCHEDULE_TASK
{
	/** 手動執行資料追蹤。 */
	ManuallyTrack				= 'manuallyTrack'
}

/** 排程工作狀態。 */
export enum SCHEDULE_STATUS
{
	/** 已排程，等待執行。 */
	Waiting						= 'waiting',

	/** 執行中。 */
	Processing					= 'processing',

	/** 執行完成。 */
	Finished					= 'finished',

	/** 執行失敗。 */
	Failed						= 'failed',

	/** 已刪除。 */
	Deleted						= 'deleted',
}

//-----------------------------------------------------------------------
// 外部擴充功能相關。

/** 外部擴充資料來源定義。 */
export enum EXTERNAL_DATA_SOURCE
{
	/** Facebook。 */
	Facebook					= 'facebook',
}

/** 外部擴充工作種類定義。 */
export enum EXTERNAL_TASK_TYPE
{
	/** 搜尋資訊抓取。 */
	ChannelInfo					= 'channelInfo',

	/** 搜尋頻道。 */
	ChannelSearch				= 'channelSearch'
}